import * as React from 'react';
import { isSameMonth } from 'date-fns';
import { MonthsDropdown, Navigation, YearsDropdown } from '..';
import { useDayPicker, useNavigation } from "../../contexts";
/**
 * Render the caption of a month, which includes title and navigation buttons.
 * The caption has a different layout when setting the `numberOfMonths` prop.
 */

export function Caption(props) {
  var _a;

  var displayMonth = props.displayMonth;
  var context = useDayPicker();
  var classNames = context.classNames,
      numberOfMonths = context.numberOfMonths,
      disableNavigation = context.disableNavigation,
      styles = context.styles,
      captionLayout = context.captionLayout,
      onMonthChange = context.onMonthChange,
      dir = context.dir,
      CaptionLabel = context.components.CaptionLabel;

  var _b = useNavigation(),
      previousMonth = _b.previousMonth,
      nextMonth = _b.nextMonth,
      goToMonth = _b.goToMonth,
      displayMonths = _b.displayMonths;

  var handlePreviousClick = function handlePreviousClick(e) {
    if (!previousMonth) return;
    goToMonth(previousMonth);
    onMonthChange === null || onMonthChange === void 0 ? void 0 : onMonthChange(previousMonth);
  };

  var handleNextClick = function handleNextClick(e) {
    if (!nextMonth) return;
    goToMonth(nextMonth);
    onMonthChange === null || onMonthChange === void 0 ? void 0 : onMonthChange(nextMonth);
  };

  var handleMonthChange = function handleMonthChange(newMonth) {
    goToMonth(newMonth);
    onMonthChange === null || onMonthChange === void 0 ? void 0 : onMonthChange(newMonth);
  };

  var displayIndex = displayMonths.findIndex(function (month) {
    return isSameMonth(displayMonth, month);
  });
  var isFirst = displayIndex === 0;
  var isLast = displayIndex === displayMonths.length - 1;

  if (dir === 'rtl') {
    _a = [isFirst, isLast], isLast = _a[0], isFirst = _a[1];
  }

  var captionLabel = /*#__PURE__*/React.createElement(CaptionLabel, {
    displayMonth: displayMonth
  });
  var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
  var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames.caption,
    style: styles.caption
  }, disableNavigation && captionLabel, !disableNavigation && /*#__PURE__*/React.createElement(React.Fragment, null, captionLayout === 'dropdown' ? /*#__PURE__*/React.createElement("div", {
    className: classNames.caption_dropdowns,
    style: styles.caption_dropdowns
  }, /*#__PURE__*/React.createElement(MonthsDropdown, {
    onChange: handleMonthChange,
    displayMonth: displayMonth
  }), /*#__PURE__*/React.createElement(YearsDropdown, {
    onChange: handleMonthChange,
    displayMonth: displayMonth
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CaptionLabel, {
    displayMonth: displayMonth
  }), /*#__PURE__*/React.createElement(Navigation, {
    displayMonth: displayMonth,
    hideNext: hideNext,
    hidePrevious: hidePrevious,
    nextMonth: nextMonth,
    previousMonth: previousMonth,
    onPreviousClick: handlePreviousClick,
    onNextClick: handleNextClick
  }))));
}